import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  const items = [t("mq1"), t("mq2"), t("mq3"), t("mq4"), t("mq6")];
  return (
    <div className="border-y border-brand/15 bg-navy-800/60 py-6" data-testid="editorial-marquee">
      <Marquee speed={20} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="mx-10 flex items-center gap-10">
            <span className="font-serif italic text-2xl text-cream/70 whitespace-nowrap">{item}</span>
            <span className="text-brand text-sm">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
